require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./smart-responsive-interface-design-patterns.json") })
        }
      }, "path---smart-responsive-interface-design-patterns");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---smart-responsive-interface-design-patterns!./.cache/json/smart-responsive-interface-design-patterns.json
// module id = 493
// module chunks = 231608221292675